import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Network, Monitor, Cloud, Shield, Database } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
import { translations } from '../translations';

export function Monitoring() {
  const { language } = useLanguage();
  const t = translations.monitoring;

  const subservices = [
    {
      icon: <Network className="w-12 h-12 text-blue-500" />,
      title: {
        fr: 'Surveillance Réseau',
        en: 'Network Monitoring'
      },
      description: {
        fr: 'Surveillance continue du trafic réseau et détection des menaces',
        en: 'Continuous network traffic monitoring and threat detection'
      },
      path: '/monitoring/network'
    },
    {
      icon: <Monitor className="w-12 h-12 text-blue-500" />,
      title: {
        fr: 'Surveillance des Endpoints',
        en: 'Endpoint Monitoring'
      },
      description: {
        fr: 'Protection complète des postes de travail et serveurs',
        en: 'Comprehensive workstation and server protection'
      },
      path: '/monitoring/endpoint'
    },
    {
      icon: <Cloud className="w-12 h-12 text-blue-500" />,
      title: {
        fr: 'Sécurité Cloud',
        en: 'Cloud Security'
      },
      description: {
        fr: 'Sécurisation des environnements cloud et surveillance continue',
        en: 'Cloud environment security and continuous monitoring'
      },
      path: '/monitoring/cloud'
    },
    {
      icon: <Shield className="w-12 h-12 text-blue-500" />,
      title: {
        fr: 'Sécurité des Applications',
        en: 'Application Security'
      },
      description: {
        fr: 'Protection des applications web et surveillance des vulnérabilités',
        en: 'Web application protection and vulnerability monitoring'
      },
      path: '/monitoring/application'
    },
    {
      icon: <Database className="w-12 h-12 text-blue-500" />,
      title: {
        fr: 'Gestion des Logs',
        en: 'Log Management'
      },
      description: {
        fr: 'Collecte centralisée et analyse des logs de sécurité',
        en: 'Centralized collection and analysis of security logs'
      },
      path: '/monitoring/logs'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero Section */}
      <div className="hero-pattern py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <Eye className="w-16 h-16 text-blue-500 mx-auto mb-6" />
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {t.hero.title[language]}
            </h1>
            <p className="text-xl text-gray-300">
              {t.hero.subtitle[language]}
            </p>
          </div>
        </div>
      </div>

      {/* Services Grid */}
      <div className="container mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {subservices.map((service, index) => (
            <Link 
              key={index}
              to={service.path}
              className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-lg border border-gray-700/50 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105"
            >
              <div className="mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-white mb-3">
                {service.title[language]}
              </h3>
              <p className="text-gray-300">
                {service.description[language]}
              </p>
            </Link>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-6 py-20">
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            {t.cta.title[language]}
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            {t.cta.subtitle[language]}
          </p>
          <button className="bg-white text-blue-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105">
            {t.cta.button[language]}
          </button>
        </div>
      </div>
    </div>
  );
}